document.addEventListener("DOMContentLoaded", () => {

  const input = document.getElementById("si");
  const clearBtn = document.getElementById("sc");
  const heroCounter = document.getElementById("sr");

  const resultPanel = document.getElementById("search-results-panel");
  const resultWrap = document.getElementById("search-results");
  const total = document.getElementById("search-total");
  const queryText = document.getElementById("search-query");
  const clearSearch = document.getElementById("clear-search");

  const tabs = document.querySelector(".tw");
  const brandPanels = document.querySelectorAll(".fp");

  const json = document.getElementById("faq-search-data");
  const data = json ? JSON.parse(json.textContent) : [];

  /* ----------------------------------------
     Escape regex
  ---------------------------------------- */

  function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  /* ----------------------------------------
     Highlight text
  ---------------------------------------- */

  function highlight(text, keyword) {
    if (!keyword) return text;
    const regex = new RegExp(`(${escapeRegExp(keyword)})`, "ig");
    return text.replace(regex, "<mark>$1</mark>");
  }

  /* ----------------------------------------
     Scroll helper (desktop + mobile)
     - always scrolls (no "only if above viewport" check, which fails
       when the tab bar is sticky)
     - accounts for sticky header + sticky tab bar
     - works even if the scroll container isn't window
  ---------------------------------------- */

  function stickyHeight(el) {
    if (!el) return 0;
    const pos = getComputedStyle(el).position;
    return (pos === "sticky" || pos === "fixed") ? el.offsetHeight : 0;
  }

  // Lenis (smooth-scroll library) is active on this theme (<html class="lenis">),
  // so we must scroll through it, otherwise it overrides window.scrollTo.
  function getLenis() {
    return window.lenis || window.lenisInstance || window.__lenis || null;
  }

  function doScroll(el) {

    // Theme exposes the sticky header height as a CSS variable
    const cssH = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue("--header-height")
    );
    const header = document.querySelector("header");
    const headerH = cssH > 0 ? cssH : (header ? header.offsetHeight : 0);

    const offset = headerH + stickyHeight(tabs) + 10;

    const top = Math.max(
      el.getBoundingClientRect().top + window.pageYOffset - offset,
      0
    );

    const lenis = getLenis();

    if (lenis && typeof lenis.scrollTo === "function") {
      if (typeof lenis.resize === "function") lenis.resize(); // page height changed
      lenis.scrollTo(top, { immediate: true, force: true });
    } else {
      window.scrollTo({ top, behavior: "auto" });
    }
  }

  function scrollToEl(el) {

    if (!el) return;

    // run now, after layout, and once more after any CSS transition
    doScroll(el);
    requestAnimationFrame(() => doScroll(el));
    setTimeout(() => doScroll(el), 150);
  }

  /* ----------------------------------------
     Accordion
  ---------------------------------------- */

  function bindAccordion(scope = document) {

    scope.querySelectorAll(".fq").forEach(btn => {

      if (btn.dataset.bound) return;

      btn.dataset.bound = "1";

      btn.addEventListener("click", () => {

        const item = btn.closest(".fi");
        const answer = item.querySelector(".fa");

        const isOpen = item.classList.contains("open");

        // Close all other FAQs in the same scope
        scope.querySelectorAll(".fi.open").forEach(openItem => {

          if (openItem === item) return;

          openItem.classList.remove("open");

          const openAnswer = openItem.querySelector(".fa");
          if (openAnswer) openAnswer.style.maxHeight = null;

        });

        // Toggle clicked FAQ
        if (isOpen) {
          item.classList.remove("open");
          answer.style.maxHeight = null;
        } else {
          item.classList.add("open");
          answer.style.maxHeight = answer.scrollHeight + "px";
        }

      });

    });

  }

  bindAccordion();

  /* ----------------------------------------
     Brand Tabs
  ---------------------------------------- */

  document.querySelectorAll(".tb").forEach(tab => {

    tab.addEventListener("click", () => {

      if (input && input.value.trim() !== "") return;

      const category = tab.dataset.category;

      document.querySelectorAll(".tb").forEach(t => t.classList.remove("on"));
      tab.classList.add("on");

      let activePanel = null;

      brandPanels.forEach(panel => {
        const isActive = panel.dataset.category === category;
        panel.classList.toggle("on", isActive);
        if (isActive) activePanel = panel;
      });

      scrollToEl(activePanel);

    });

  });

  /* ----------------------------------------
     Category Filter
  ---------------------------------------- */

  brandPanels.forEach(panel => {

    const buttons = panel.querySelectorAll(".fcat");
    const select = panel.querySelector(".fcat-select");

    function filter(cat) {

      buttons.forEach(btn => {
        btn.classList.toggle("on", btn.dataset.cat === cat);
      });

      if (select) select.value = cat;

      panel.querySelectorAll(".catsec").forEach(section => {
        section.classList.toggle(
          "hidden-cat",
          cat !== "" && section.dataset.cat !== cat
        );
      });

      // Close any open accordion so stale heights don't linger
      panel.querySelectorAll(".fi.open").forEach(item => {
        item.classList.remove("open");
        const a = item.querySelector(".fa");
        if (a) a.style.maxHeight = null;
      });

      // Keep the user at the top of the FAQ area
      scrollToEl(panel);

    }

    buttons.forEach(btn => {
      btn.addEventListener("click", e => {
        e.preventDefault(); // in case buttons are <a href="#">
        filter(btn.dataset.cat);
      });
    });

    if (select) {
      select.addEventListener("change", () => filter(select.value));
    }

  });

  /* ----------------------------------------
     Search
  ---------------------------------------- */

  function getBrandColor(brand) {
    const colors = {
      "tulip": "var(--tulip)",
      "aleene's": "var(--al)",
      "aleenes": "var(--al)",
      "colorshot": "var(--cs)",
      "puffy": "var(--pf)",
      "scribbles": "var(--sc)",
      "bebold": "var(--by)",
      "createbasic": "var(--ba)",
      "orders": "var(--navy)",
      "orders & support": "var(--navy)"
    };

    return colors[brand.toLowerCase()] || "var(--navy)";
  }

  function buildResults(keyword) {

    const term = keyword.trim().toLowerCase();

    if (term === "") {

      heroCounter.textContent = "";
      resultPanel.hidden = true;

      tabs.style.display = "";
      brandPanels.forEach(p => p.style.display = "");

      return;

    }

    /* unique faq search */

    const found = [];
    const seen = new Set();

    data.forEach(item => {

      const hit =
        item.question.toLowerCase().includes(term) ||
        item.answer.toLowerCase().includes(term);

      if (!hit) return;

      const key = item.brand + "|" + item.category + "|" + item.question;

      if (seen.has(key)) return;

      seen.add(key);
      found.push(item);

    });

    total.textContent = found.length;
    queryText.textContent = keyword;
    heroCounter.textContent = `${found.length} results across all brands`;

    tabs.style.display = "none";
    brandPanels.forEach(p => p.style.display = "none");

    resultPanel.hidden = false;

    /* group by subcategory */

    const grouped = {};

    found.forEach(item => {

      const subCategory = item.subCategory || "General";

      if (!grouped[subCategory]) grouped[subCategory] = [];

      grouped[subCategory].push(item);

    });

    let html = "";

    Object.keys(grouped).forEach(subCategory => {

      html += `

        <div class="sr-brand">

          <div class="sr-brand-head">
            <div class="sr-brand-name h5">${subCategory}</div>

            <div class="sr-brand-count">
              ${grouped[subCategory].length} result${grouped[subCategory].length > 1 ? "s" : ""}
            </div>

          </div>

      `;

      grouped[subCategory].forEach(item => {

        html += `

          <div class="fi search-fi">

            <button class="fq">

              <span class="fq-t">
                ${highlight(item.question, keyword)}
              </span>

              <svg class="fq-c" width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.76144 5.76144L10.3708 1.15213L9.21863 4.02959e-07L5.18538 4.03325L1.15212 5.0361e-08L0 1.15212L4.60931 5.76144C4.76211 5.91419 4.96932 6 5.18538 6C5.40143 6 5.60864 5.91419 5.76144 5.76144Z" fill="black"/>
              </svg>

            </button>

            <div class="fa">

              <div class="fa-in">

                <div class="sr-path">
                  ${item.category}
                </div>

                ${highlight(item.answer, keyword)}

              </div>

            </div>

          </div>

        `;

      });

      html += "</div>";

    });

    resultWrap.innerHTML = html;

    bindAccordion(resultWrap);

  }

  /* ----------------------------------------
     Events
  ---------------------------------------- */

  if (input) {
    input.addEventListener("input", e => {
      buildResults(e.target.value);
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener("click", () => {
      input.value = "";
      buildResults("");
    });
  }

  if (clearSearch) {
    clearSearch.addEventListener("click", () => {
      input.value = "";
      buildResults("");
    });
  }

});